export default {
    props: {
        filterField: {
            type: String,
            kComposite: 'filter.field'
        },
        filterFilters: {
            type: Array,
            kComposite: 'filter.filters'
        },
        filterLogic: {
            type: String,
            kComposite: 'filter.logic'
        },
        filterOperator: {
            type: String | Function,
            kComposite: 'filter.operator'
        },
        filterValue: {
            type: String | Number | Date | Object,
            kComposite: 'filter.value'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-datasource-vue-wrapper/src/KendoDataSourceBase/Filter.js